export default {
  loginDev: "/developer/api/adxAdmin/login", //测试环境登录
  // 'login': '/user/login',
  logout: "user/logout",
  signup: "/user/signup",
  userCaptcha: "/user/captcha",
  userSendCode: "/user/send-code",
  userSendEmail: "/user/send-email",
  validateCaptcha: "/user/validate-captcha",
  validatePhone: "/user/validate-phone",
  // 公共首页
  appList: "/app/list",
  appAdd: "/app/add",
  appEdit: "/app/edit",
  appView: "/app/view",
  appDelete: "app/delete",
  docInfo: "/doc/info",
  accountAdd: "/account/add",
  accountView: "/account/view",
  financeList: "/finance/list",
  financeBill: "/finance/bill",
  //dp
  dpushAppList: "/dpush/app/list",
  dpushAppAdd: "/dpush/app/add",
  dpushAppEdit: "/dpush/app/edit",
  dpushAppView: "/dpush/app/view",
  dpushStatsApp: "/dpush/stats/app",
  dpushStatsSettle: "/dpush/stats/settle",
  // ad 应用管理
  dimList: "/developer/api/dim",
  sspAppList: "/developer/api/application/getList",
  sspAppAdd: "/developer/api/application/addOrUpdate",
  sspAppEdit: "/ssp/app/edit",
  sspAppView: "/ssp/app/view",
  sspPositionAdd: "/developer/api/adZone/addOrUpdate",
  sspPositionList: "/developer/api/adZone/getList",
  sspPositionEdit: "/ssp/ad-position/edit",
  sspPositionView: "/ssp/ad-position/view",
  sspPositionPaused: "/ssp/ad-position/paused",
  sspPositionResume: "/ssp/ad-position/resume",
  sspStatsInfo: "/ssp/stats/info",
  getLineStatus: "/developer/api/sdk/errorsLine",
  // 数据
  getSumStatisticInfo: "/developer/api/stats",
  // 报表流式导出（返回 CSV 文件流，仅国内）
  getStatsExportStream: "/developer/api/stats/export",
  getExchangeId: "/developer/api/exchange/getIdByMediaId",
  getUserInfo: "/developer/api/adxAdmin/login",
  getAppCategory: "/developer/api/application/getAppCategory",
  // 对账
  getMonthStatsList: "/developer/api/monthStats/list",
  // 查询应用下拉框数据
  getAppListAll: "/developer/api/application/getAll",
  getRestList: '/developer/api/V2/dim',
  // 查询自定义列数据
  getcustomColumnList: '/developer/api/V2/stats',
  // 查询广告位下拉框数据
  getAdListAll: "/developer/api/adZone/getAll",
  adAddOrUpdate: "/developer/api/adZone/addOrUpdate",
  adAddOrUpdateBatch: '/developer/api/adZone/addBatch',
  getAdDetail: "/developer/api/adZone/getDetail",
  // CSV文件相关接口
  downloadAdZoneTemplate: "/developer/api/adZone/downloadTemplate",
  parseAdZoneNamesFile: "/developer/api/adZone/parseNamesFile",
  // 广告位id修改
  updateZoneId: "/developer/api/adZone/updateZoneId",
  // sdk测试工具
  getSdkTestingList: "/developer/api/sdkTesting/list",
  addSdkTesting: "/developer/api/sdkTesting/add",
  delSdkTesting: "/developer/api/sdkTesting/delete",
  updateTestStatus: "/developer/api/sdkTesting/updateTestStatus",
  getSdkZoneSelect: "/developer/api/common/zoneSelect",
  // appadsTxt
  getTxt: "/developer/api/sdk/appAdsTxt",
  // 获取图片验证码
  getCaptcha: "developer/api/user/captcha",
  // 获取短信验证码
  getSms: "developer/api/user/sms",
  // 获取邮箱验证码
  getEmailCode: "developer/api/user/emailCode",
  // 监测邮箱手机号是否注册
  registerCheck: "developer/api/user/registerCheck",
  // 注册
  registe: "developer/api/user/register",
  // 登录
  login: "developer/api/user/login",
  // 重置密码
  reset: "developer/api/user/resetPassword",
  // 海外注册
  abroadRegiste: "/developer/api/user/sspUser/register",
  // 注册页企业信息
  companyInfoRegister: "/developer/api/user/profile",
  //获取国家信息
  getCountryList: "/developer/abroadApi/countryInfo",
  // 获取企业信息
  getCompanyInfo: "/developer/api/sspUser/profile",
  // 更新企业信息
  updateCompanyInfo: "/developer/api/sspUser/profile",
  // 获取屏蔽规则表
  getBlockedRules: "/developer/api/block/list",
  // 添加/更新屏蔽规则
  updateBlockedRule: "/developer/api/block/addOrUpdate",
  // 删除屏蔽规则
  deleteBlockedRule: "/developer/api/block/delete",
  // 获取行业屏蔽类别树
  getCategoryTrees: "/developer/api/block/categories_list",
  // 获取生效应用范围列表
  getAppScopeList: "/developer/api/block/application_list"
};
